import React from "react";
import { Box } from "@mui/material";

// Speaker pattern regex - matches Doctor:, Dentist:, or Patient:
const SPEAKER_PATTERN = /^(Doctor|Dentist|Patient):/i;

/**
 * Format transcript to display Doctor/Dentist/Patient lines on separate paragraphs
 * @param transcript - Raw transcript string with speaker labels
 * @returns Formatted React nodes with each speaker on a separate line
 */
export const formatTranscript = (transcript: string): React.ReactNode => {
  if (!transcript) return null;

  // First split by newlines to handle \n separated lines
  const lines = transcript.split(/\n/).filter((line) => line.trim());

  const formattedParts: React.ReactNode[] = [];

  for (const line of lines) {
    const trimmedLine = line.trim();
    if (!trimmedLine) continue;

    // Check if line starts with a speaker label
    const speakerMatch = trimmedLine.match(SPEAKER_PATTERN);

    if (speakerMatch) {
      const speaker = speakerMatch[0]; // e.g., "Doctor:"
      const content = trimmedLine.slice(speaker.length).trim();

      formattedParts.push(
        <Box
          component="p"
          key={formattedParts.length}
          sx={{ m: 0, lineHeight: "24px" }}
        >
          {speaker} {content}
        </Box>
      );
    } else {
      // Line without a speaker label
      formattedParts.push(
        <Box
          component="p"
          key={formattedParts.length}
          sx={{ m: 0, lineHeight: "24px" }}
        >
          {trimmedLine}
        </Box>
      );
    }
  }

  return <>{formattedParts}</>;
};
